import React, { useEffect, useState, useRef } from "react";
import {
  GetSalesVoucherList,
  ApproveSalesVoucher,
  SalesVoucherDelete,
  ExportSalesVouchersToExcel,
} from "../../../Services/Services";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  Modal,
  Box,
  TextField,
  MenuItem,
  Popover,
  Typography,
  Checkbox,
  Autocomplete,
  Grid,
  Chip,
  Menu,
  Divider,
  useMediaQuery,
  Collapse,
} from "@mui/material";

import { useTheme } from "@mui/material/styles";
import {
  Edit,
  Delete,
  Print,
  Visibility,
  Add,
  Close,
} from "@mui/icons-material";
import {
  ExpandMore,
  ExpandLess,
  Description as FileIcon,
} from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import { Tooltip } from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import AddIcon from "@mui/icons-material/Add";
import { toast, ToastContainer } from "react-toastify";
import { generateSalesPdf } from "./SaleVoucherPrint";
import "react-toastify/dist/ReactToastify.css";
import config from "../../../config";
import { useNavigate } from "react-router-dom";

const SalesVouchers = () => {
  // ===== States =====

  const [SalesVouchers, setSalesVouchers] = useState([]);

  const [anchorEl, setAnchorEl] = useState(null);
  const [voucherToDelete, setVoucherToDelete] = useState(null);

  // NEW STATES FOR MODALS
  const [previewModalOpen, setPreviewModalOpen] = useState(false);
  const [remarkModalOpen, setRemarkModalOpen] = useState(false);
  const [selectedVoucher, setSelectedVoucher] = useState(null);
  const [remarkInput, setRemarkInput] = useState("");
  const [actionType, setActionType] = useState(null);

  const [filters, setFilters] = useState({
    sales_no: "",
    project_name: "",
    party_name: "",
    date_range: "this_month",
    salevoucher_date_from: "",
    salevoucher_date_to: "",
  });
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [dateMenuAnchor, setDateMenuAnchor] = useState(null);
  const [selectingDate, setSelectingDate] = useState(null);
  const dateInputRef = useRef(null);
  const [excelLoading, setExcelLoading] = useState(false);
  const [showCustomDateInputs, setShowCustomDateInputs] = useState(false);
  const [tempCustomDateRange, setTempCustomDateRange] = useState({
    from: "",
    to: "",
  });
  const [customDateRange, setCustomDateRange] = useState({
    from: "",
    to: "",
  });
  const [salevoucherDateMenuAnchor, setSaleVoucherDateMenuAnchor] =
    useState(null);
  const [saleVoucherDateRange, setPaymentDateRange] = useState({
    from: "",
    to: "",
  });
  const [tempSaleVoucherDateRange, setTempSaleVoucherDateRange] = useState({
    from: "",
    to: "",
  });
  const navigate = useNavigate();
  // Existing states ke saath ye add karo
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // 👈 Mobile detection
  const [expandedSales, setExpandedSales] = useState(null); // 👈 Mobile expand/collapse

  const handleExportToExcel = async () => {
    try {
      if (SalesVouchers.length === 0) {
        toast.warning("No data available to export");
        return;
      }

      setExcelLoading(true);
      const exportParams = { ...filters };

      // Add custom date range if selected
      if (
        filters.date_range === "custom" &&
        customDateRange.from &&
        customDateRange.to
      ) {
        exportParams.from_date = customDateRange.from;
        exportParams.to_date = customDateRange.to;
      }

      // Add sales voucher date range if selected
      if (filters.salevoucher_date_from && filters.salevoucher_date_to) {
        exportParams.salevoucher_date_from = filters.salevoucher_date_from;
        exportParams.salevoucher_date_to = filters.salevoucher_date_to;
      }

      // Call the export service
      const blob = await ExportSalesVouchersToExcel(exportParams);

      // Create a download link
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;

      // Generate filename with current date
      const today = new Date();
      const dateStr = `${today.getFullYear()}-${(today.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${today.getDate().toString().padStart(2, "0")}`;
      link.download = `sales_vouchers_${dateStr}.xlsx`;

      // Trigger download
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);

      // Dismiss loading toast and show success
      toast.dismiss(excelLoading);
      toast.success("Excel file downloaded successfully!");
    } catch (error) {
      console.error("Export error:", error);
      toast.error(
        error.response?.data?.message || "Failed to export data to Excel"
      );
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setPage(1);
      fetchVouchers(1, true, filters);
    }, 500);

    return () => clearTimeout(handler);
  }, [filters, customDateRange, saleVoucherDateRange]);

  const fetchVouchers = async (
    pageNum = 1,
    reset = false,
    filterValues = filters
  ) => {
    // 🆕 Build params with custom date handling
    const params = { ...filterValues };

    // Add custom dates if custom range selected
    if (
      filterValues.date_range === "custom" &&
      customDateRange.from &&
      customDateRange.to
    ) {
      params.from_date = customDateRange.from;
      params.to_date = customDateRange.to;
    }
    if (
      filterValues.salevoucher_date_from &&
      filterValues.salevoucher_date_to
    ) {
      params.salevoucher_date_from = filterValues.salevoucher_date_from;
      params.salevoucher_date_to = filterValues.salevoucher_date_to;
    }
    console.log("API Params being sent:", params);
    const data = await GetSalesVoucherList(params, pageNum);

    if (reset || pageNum === 1) {
      setSalesVouchers(Array.isArray(data) ? data.results : data.results || []);
    } else {
      setSalesVouchers((prev) => [
        ...prev,
        ...(Array.isArray(data) ? data.results : data.results || []),
      ]);
    }

    setHasMore(Array.isArray(data) ? data.next !== null : data.next !== null);
    setPage(pageNum);
  };

  const fetchMoreData = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchVouchers(nextPage);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const truncateText = (text, limit = 20) => {
    if (!text) return "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };

  const handleReset = () => {
    setFilters({
      sales_no: "",
      project_name: "",
      party_name: "",
      date_range: "this_month", // 🆕 Default to this_month
      salevoucher_date_from: "",
      salevoucher_date_to: "",
    });
    setCustomDateRange({ from: "", to: "" }); // 🆕 Reset custom dates
    setSelectingDate(null); // 🆕
    setSalesVouchers([]);
    setPage(1);
    setHasMore(true);
    setTempCustomDateRange({ from: "", to: "" });
    setShowCustomDateInputs(false);
    setPaymentDateRange({ from: "", to: "" });
    setTempSaleVoucherDateRange({ from: "", to: "" });
  };

  const handleCancelCustomDateRange = () => {
    setTempCustomDateRange({ from: "", to: "" });
    setShowCustomDateInputs(false);
  };

  const handleApplyCustomDateRange = () => {
    if (tempCustomDateRange.from && tempCustomDateRange.to) {
      setCustomDateRange({
        from: tempCustomDateRange.from,
        to: tempCustomDateRange.to,
      });
      setFilters((prev) => ({ ...prev, date_range: "custom" }));
      setDateMenuAnchor(null);
      setShowCustomDateInputs(false);
    } else {
      toast.warning("Please select both From and To dates");
    }
  };

  const handleDelete = async (voucherId) => {
    try {
      // Delete from backend
      await SalesVoucherDelete(voucherId);

      // Option 1: Refresh from API (maintains pagination/filters)
      if (filters.sales_no || filters.project_name || filters.party_name) {
        // If filters active, fetch with filters
        const response = await GetSalesVoucherList(filters, page);
        setSalesVouchers(response.results || []);
      } else {
        // Option 2: Just remove from current state (faster)
        setSalesVouchers((prevVouchers) =>
          prevVouchers.filter(
            (voucher) => voucher.sales_voucher_no !== voucherId
          )
        );
      }

      toast.success("Deleted successfully!");
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Delete failed.");
    }
  };

  // NEW: Handle Checkbox Click to Open Modal
  const handleCheckboxClick = (voucher) => {
    setSelectedVoucher(voucher);
    setPreviewModalOpen(true);
    setRemarkInput("");
    setActionType(null);
  };

  // NEW: Open Remark Dialog Box
  const handleOpenRemarkDialog = (type) => {
    setActionType(type);
    setRemarkModalOpen(true);
    setRemarkInput("");
  };

  // NEW: Handle Approve/Reject from Modal
  const handleApproveReject = async () => {
    if (!selectedVoucher || !actionType) return;

    if (!remarkInput.trim()) {
      toast.error("Please enter a remark!");
      return;
    }

    const approvedById = Number(localStorage.getItem("user_id"));
    if (!approvedById) {
      toast.error("Approver ID not found.");
      return;
    }

    try {
      const updated = await ApproveSalesVoucher(
        selectedVoucher.sales_voucher_no,
        approvedById,
        actionType,
        remarkInput
      );

      setSalesVouchers((prev) =>
        prev.map((item) =>
          item.sales_voucher_no === updated.sales_voucher_no ? updated : item
        )
      );

      toast.success(
        `Sales Voucher ${
          actionType === "Approved" ? "approved" : "rejected"
        } successfully!`
      );
      setPreviewModalOpen(false);
      setRemarkModalOpen(false);
      setSelectedVoucher(null);
      setRemarkInput("");
      setActionType(null);
    } catch (error) {
      console.error("Approval Error:", error);
      toast.error("Failed to update Sales Voucher status.");
    }
  };

  const userRole = localStorage.getItem("role"); // "admin" ya "staff"

  const handleEditClick = async (voucher) => {
    navigate("/dashboard/sales-voucher-create", {
      state: {
        editMode: true,
        voucherData: voucher,
      },
    });
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
    document.body.style.overflow = "hidden"; // disable window scroll

    return () => {
      document.body.style.overflow = "auto"; // cleanup: scroll wapas enable
    };
  }, []);

  // 🆕 Helper function to format date display
  const formatDateDisplay = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };

  // 🆕 Get date range display text
  const getDateRangeDisplay = (rangeType) => {
    const now = new Date();
    const formatDate = (date) => {
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };

    switch (rangeType) {
      case "today":
        return formatDate(now);
      case "yesterday":
        const yesterday = new Date(now);
        yesterday.setDate(yesterday.getDate() - 1);
        return formatDate(yesterday);
      case "this_week":
        const weekStart = new Date(now);
        weekStart.setDate(weekStart.getDate() - weekStart.getDay() + 1);
        return `${formatDate(weekStart)} to ${formatDate(now)}`;
      case "previous_week":
        const prevWeekEnd = new Date(now);
        prevWeekEnd.setDate(prevWeekEnd.getDate() - prevWeekEnd.getDay());
        const prevWeekStart = new Date(prevWeekEnd);
        prevWeekStart.setDate(prevWeekStart.getDate() - 6);
        return `${formatDate(prevWeekStart)} to ${formatDate(prevWeekEnd)}`;
      case "this_month":
        const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
        return `${formatDate(monthStart)} to ${formatDate(now)}`;
      case "current_year":
        const yearStart = new Date(now.getFullYear(), 0, 1);
        return `${formatDate(yearStart)} to ${formatDate(now)}`;
      case "financial_year":
        let fyStart;
        if (now.getMonth() >= 3) {
          fyStart = new Date(now.getFullYear(), 3, 1);
        } else {
          fyStart = new Date(now.getFullYear() - 1, 3, 1);
        }
        return `${formatDate(fyStart)} to ${formatDate(now)}`;
      default:
        return "";
    }
  };

  // Handle Apply
  const handleApplySaleVoucherDateRange = () => {
    setPaymentDateRange(tempSaleVoucherDateRange);
    setFilters((prev) => ({
      ...prev,
      salevoucher_date_from: tempSaleVoucherDateRange.from,
      salevoucher_date_to: tempSaleVoucherDateRange.to,
      date_range: "all",
    }));
    setSaleVoucherDateMenuAnchor(null);
  };

  // Handle Cancel
  const handleCancelSaleVoucherDateRange = () => {
    setTempSaleVoucherDateRange(saleVoucherDateRange);
    setSaleVoucherDateMenuAnchor(null);
  };

  // Handle Clear
  const handleClearSaleVoucherDateRange = () => {
    setPaymentDateRange({ from: "", to: "" });
    setTempSaleVoucherDateRange({ from: "", to: "" });
    setFilters((prev) => ({
      ...prev,
      salevoucher_date_from: "",
      salevoucher_date_to: "",
    }));
    setSaleVoucherDateMenuAnchor(null);
  };

  useEffect(() => {
    document.body.style.overflow = isMobile ? "auto" : "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMobile]);

  // Modal styles
const voucherModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "95%", sm: "90%", md: "80%", lg: 700 },
  maxWidth: 700,
  maxHeight: { xs: "95vh", sm: "90vh" },
  bgcolor: "background.paper",
  borderRadius: { xs: 1, sm: 2 },
  boxShadow: 24,
  overflow: "auto",
};

const remarkModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90%", sm: 400 },
  maxWidth: 400,
  bgcolor: "background.paper",
  borderRadius: { xs: 1, sm: 2 },
  boxShadow: 24,
  p: { xs: 2, sm: 3 },
};


  return (
    <>
      <ToastContainer />

      {/* Filter Section */}
      <Box sx={{ mt: -5, pt: -3, mb: 2, width: "100%" }}>
        <Grid container spacing={2} alignItems="center">
          {/* Date Range Dropdown */}
          <Grid item xs={12} sm={2}>
            <TextField
              label="Date Range"
              value={
                filters.date_range === "custom" &&
                customDateRange.from &&
                customDateRange.to
                  ? `${formatDateDisplay(
                      customDateRange.from
                    )} to ${formatDateDisplay(customDateRange.to)}`
                  : filters.date_range === "today"
                  ? "Today"
                  : filters.date_range === "yesterday"
                  ? "Yesterday"
                  : filters.date_range === "this_week"
                  ? "This Week"
                  : filters.date_range === "previous_week"
                  ? "Previous Week"
                  : filters.date_range === "this_month"
                  ? "This Month"
                  : filters.date_range === "current_year"
                  ? "Current Year"
                  : filters.date_range === "financial_year"
                  ? "Financial Year"
                  : "Select Date Range"
              }
              onClick={(e) => setDateMenuAnchor(e.currentTarget)}
              size="small"
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <IconButton size="small" edge="end">
                    <ArrowDropDownIcon />
                  </IconButton>
                ),
              }}
              sx={{
                cursor: "pointer",
                fontWeight: "bold",
                "& .MuiInputBase-input": {
                  fontSize: "0.8rem",
                  padding: "4px 8px",
                },
                "& .MuiInputBase-root": {
                  height: 30,
                  borderRadius: 0,
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.6rem",
                },
              }}
            />
          </Grid>

          {/* Project */}
          <Grid item xs={12} sm={2}>
            <TextField
              label="Project"
              name="project_name"
              size="small"
              value={filters.project_name}
              onChange={handleFilterChange}
              sx={{
                "& .MuiInputBase-root": {
                  height: 30,
                  borderRadius: 0,
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.7rem",
                },
              }}
              fullWidth
            />
          </Grid>

          {/* Debtor */}
          <Grid item xs={12} sm={2}>
            <TextField
              label="Debtor"
              name="party_name"
              size="small"
              value={filters.party_name}
              onChange={handleFilterChange}
              sx={{
                "& .MuiInputBase-root": {
                  height: 30,
                  borderRadius: 0,
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.7rem",
                },
              }}
              fullWidth
            />
          </Grid>

          {/* Sale Voucher Date */}
          <Grid item xs={12} sm={2}>
            <TextField
              label="Sale Voucher Date"
              value={
                saleVoucherDateRange.from && saleVoucherDateRange.to
                  ? `${formatDateDisplay(
                      saleVoucherDateRange.from
                    )} to ${formatDateDisplay(saleVoucherDateRange.to)}`
                  : saleVoucherDateRange.from
                  ? `From ${formatDateDisplay(saleVoucherDateRange.from)}`
                  : saleVoucherDateRange.to
                  ? `To ${formatDateDisplay(saleVoucherDateRange.to)}`
                  : ""
              }
              placeholder="Select Sale Voucher Date Range"
              onClick={(e) => {
                setSaleVoucherDateMenuAnchor(e.currentTarget);
                setTempSaleVoucherDateRange(saleVoucherDateRange);
              }}
              size="small"
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <IconButton size="small" edge="end">
                    <ArrowDropDownIcon />
                  </IconButton>
                ),
              }}
              InputLabelProps={{ shrink: true }}
              sx={{
                flex: "1 1 100px",
                cursor: "pointer",
                "& .MuiInputBase-root": {
                  height: 35,
                  borderRadius: 0,
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.65rem",
                },
                "& .MuiInputBase-input": {
                  cursor: "pointer",
                },
              }}
            />
          </Grid>

          <Menu
            anchorEl={salevoucherDateMenuAnchor}
            open={Boolean(salevoucherDateMenuAnchor)}
            onClose={handleCancelSaleVoucherDateRange}
            PaperProps={{
              sx: {
                width: 320,
                p: 0,
              },
            }}
          >
            <Box
              sx={{
                px: 2,
                py: 2,
                bgcolor: "#fafafa",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <Typography
                variant="subtitle2"
                sx={{ mb: 2, fontWeight: 600, color: "#1976d2" }}
              >
                Select Sale Voucher Date Range
              </Typography>

              {/* From and To Date Inputs */}
              <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                <TextField
                  label="From Date"
                  type="date"
                  size="small"
                  fullWidth
                  value={tempSaleVoucherDateRange.from}
                  onChange={(e) =>
                    setTempSaleVoucherDateRange((prev) => ({
                      ...prev,
                      from: e.target.value,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    max:
                      tempSaleVoucherDateRange.to ||
                      new Date().toISOString().split("T")[0],
                  }}
                  sx={{
                    flex: 1,
                    "& .MuiInputBase-root": {
                      height: 40,
                      fontSize: "0.75rem",
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.75rem",
                    },
                  }}
                />

                <TextField
                  label="To Date"
                  type="date"
                  size="small"
                  fullWidth
                  value={tempSaleVoucherDateRange.to}
                  onChange={(e) =>
                    setTempSaleVoucherDateRange((prev) => ({
                      ...prev,
                      to: e.target.value,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    min: tempSaleVoucherDateRange.from || undefined,
                    max: new Date().toISOString().split("T")[0],
                  }}
                  sx={{
                    flex: 1,
                    "& .MuiInputBase-root": {
                      height: 40,
                      fontSize: "0.75rem",
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.75rem",
                    },
                  }}
                />
              </Box>

              {/* Selected Range Preview */}
              {tempSaleVoucherDateRange.from && tempSaleVoucherDateRange.to && (
                <Typography
                  variant="caption"
                  sx={{
                    display: "block",
                    mb: 2,
                    p: 1,
                    bgcolor: "#e8f5e9",
                    borderRadius: 1,
                    textAlign: "center",
                    color: "#2e7d32",
                    fontWeight: 500,
                  }}
                >
                  📅 {formatDateDisplay(tempSaleVoucherDateRange.from)} to{" "}
                  {formatDateDisplay(tempSaleVoucherDateRange.to)}
                </Typography>
              )}

              {/* Action Buttons */}
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  justifyContent: "space-between",
                }}
              >
                <Button
                  variant="text"
                  size="small"
                  color="error"
                  onClick={handleClearSaleVoucherDateRange}
                  disabled={
                    !saleVoucherDateRange.from && !saleVoucherDateRange.to
                  }
                  sx={{
                    fontSize: "0.7rem",
                    textTransform: "none",
                  }}
                >
                  Clear
                </Button>

                <Box sx={{ display: "flex", gap: 1 }}>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleCancelSaleVoucherDateRange}
                    sx={{
                      fontSize: "0.7rem",
                      textTransform: "none",
                      borderRadius: 1,
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={handleApplySaleVoucherDateRange}
                    disabled={
                      !tempSaleVoucherDateRange.from ||
                      !tempSaleVoucherDateRange.to
                    }
                    sx={{
                      fontSize: "0.7rem",
                      textTransform: "none",
                      borderRadius: 1,
                    }}
                  >
                    Apply
                  </Button>
                </Box>
              </Box>
            </Box>
          </Menu>

          {/* Reset Button */}
          <Grid item xs={12} sm={1}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={handleReset}
              sx={{
                height: "30px",
                whiteSpace: "nowrap",
                borderRadius: "0",
                fontSize: "0.7rem",
              }}
              fullWidth
            >
              Reset
            </Button>
          </Grid>

          {/* Add Sales Button */}
          <Grid item xs={12} sm={2}>
            <Button
              variant="contained"
              onClick={() => navigate("/dashboard/sales-voucher-create")}
              sx={{
                height: 30,
                display: "flex",
                alignItems: "center",
                fontSize: "0.7rem",
                borderRadius: "0",
                whiteSpace: "nowrap",
              }}
              fullWidth
            >
              <AddIcon fontSize="small" sx={{ mr: 0.5 }} /> Sales
            </Button>
          </Grid>
          <Grid item xs={12} sm={1}>
            <IconButton
              variant="contained"
              color="success"
              size="small"
              onClick={handleExportToExcel}
              disabled={excelLoading || SalesVouchers.length === 0}
              fullWidth
              sx={{
                height: 30,
                width: 30,
                bgcolor: "success.main",
                color: "white",
                borderRadius: 0,
                "&:hover": {
                  bgcolor: "success.dark",
                },
                "&:disabled": {
                  bgcolor: "grey.400",
                  color: "white",
                },
              }}
            >
              {excelLoading ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                <FileIcon fontSize="small" />
              )}
            </IconButton>
          </Grid>
        </Grid>
      </Box>

      {/* Date Range Menu - UPDATED */}
      <Menu
        anchorEl={dateMenuAnchor}
        open={Boolean(dateMenuAnchor)}
        onClose={() => {
          setDateMenuAnchor(null);
          setShowCustomDateInputs(false);
          setTempCustomDateRange({ from: "", to: "" });
        }}
        PaperProps={{
          sx: {
            width: 350,
            maxHeight: 500,
            "& .MuiTypography-root": {
              fontSize: "0.7rem",
            },
          },
        }}
      >
        {[
          { key: "today", label: "Today" },
          { key: "yesterday", label: "Yesterday" },
          { key: "this_week", label: "This Week" },
          { key: "previous_week", label: "Previous Week" },
          { key: "this_month", label: "This Month" },
          { key: "current_year", label: "Current Year" },
          { key: "financial_year", label: "Financial Year" },
        ].map((range) => (
          <MenuItem
            key={range.key}
            onClick={() => {
              setFilters((prev) => ({ ...prev, date_range: range.key }));
              setCustomDateRange({ from: "", to: "" });
              setDateMenuAnchor(null);
              setShowCustomDateInputs(false);
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Typography variant="body2">{range.label}</Typography>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ fontSize: "0.65rem" }}
              >
                {getDateRangeDisplay(range.key)}
              </Typography>
            </Box>
          </MenuItem>
        ))}

        <Divider />

        {/* ✅ Custom Date Range - Expandable */}
        <MenuItem
          onClick={() => setShowCustomDateInputs(!showCustomDateInputs)}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            bgcolor: showCustomDateInputs ? "#e3f2fd" : "inherit",
          }}
        >
          <Typography
            variant="body2"
            sx={{ fontWeight: showCustomDateInputs ? 600 : 400 }}
          >
            Custom Date Range
          </Typography>
          {showCustomDateInputs ? <ExpandLess /> : <ExpandMore />}
        </MenuItem>

        {/* ✅ Both Date Pickers Together */}
        <Collapse in={showCustomDateInputs} timeout="auto" unmountOnExit>
          <Box
            sx={{
              px: 2,
              py: 2,
              bgcolor: "#f5f5f5",
              borderTop: "1px solid #e0e0e0",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ mb: 1, display: "block" }}
            >
              Select Date Range
            </Typography>

            {/* From and To Date Inputs Side by Side */}
            <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
              <TextField
                label="From Date"
                type="date"
                size="small"
                value={tempCustomDateRange.from}
                onChange={(e) =>
                  setTempCustomDateRange((prev) => ({
                    ...prev,
                    from: e.target.value,
                  }))
                }
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  max:
                    tempCustomDateRange.to ||
                    new Date().toISOString().split("T")[0],
                }}
                sx={{
                  flex: 1,
                  "& .MuiInputBase-root": {
                    height: 40,
                    fontSize: "0.75rem",
                  },
                  "& .MuiInputLabel-root": {
                    fontSize: "0.75rem",
                  },
                }}
              />

              <TextField
                label="To Date"
                type="date"
                size="small"
                value={tempCustomDateRange.to}
                onChange={(e) =>
                  setTempCustomDateRange((prev) => ({
                    ...prev,
                    to: e.target.value,
                  }))
                }
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  min: tempCustomDateRange.from || undefined,
                  max: new Date().toISOString().split("T")[0],
                }}
                sx={{
                  flex: 1,
                  "& .MuiInputBase-root": {
                    height: 40,
                    fontSize: "0.75rem",
                  },
                  "& .MuiInputLabel-root": {
                    fontSize: "0.75rem",
                  },
                }}
              />
            </Box>

            {/* Selected Range Preview */}
            {tempCustomDateRange.from && tempCustomDateRange.to && (
              <Typography
                variant="caption"
                sx={{
                  display: "block",
                  mb: 1.5,
                  p: 1,
                  bgcolor: "#e8f5e9",
                  borderRadius: 1,
                  textAlign: "center",
                  color: "#2e7d32",
                  fontWeight: 500,
                }}
              >
                📅 {formatDateDisplay(tempCustomDateRange.from)} to{" "}
                {formatDateDisplay(tempCustomDateRange.to)}
              </Typography>
            )}

            {/* Apply and Cancel Buttons */}
            <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
              <Button
                variant="outlined"
                size="small"
                onClick={handleCancelCustomDateRange}
                sx={{
                  fontSize: "0.7rem",
                  textTransform: "none",
                  borderRadius: 1,
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                size="small"
                onClick={handleApplyCustomDateRange}
                disabled={!tempCustomDateRange.from || !tempCustomDateRange.to}
                sx={{
                  fontSize: "0.7rem",
                  textTransform: "none",
                  borderRadius: 1,
                }}
              >
                Apply
              </Button>
            </Box>
          </Box>
        </Collapse>
      </Menu>

      {/* InfiniteScroll with Mobile/Desktop Views */}
      <InfiniteScroll
        dataLength={SalesVouchers.length}
        next={fetchMoreData}
        hasMore={hasMore}
        scrollableTarget={isMobile ? undefined : "scrollableDiv"}
        loader={<h4>Loading...</h4>}
      >
        {isMobile ? (
          /* 📱 MOBILE VIEW */
          <Box
            sx={{
              bgcolor: "background.paper",
            }}
          >
            {SalesVouchers.map((voucher, index) => (
              <Box key={voucher.id || index}>
                <Box
                  onClick={() =>
                    setExpandedSales(
                      expandedSales === voucher.sales_voucher_no
                        ? null
                        : voucher.sales_voucher_no
                    )
                  }
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 1.5,
                    cursor: "pointer",
                    bgcolor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                    "&:active": {
                      bgcolor: "#e3f2fd",
                    },
                    borderLeft: `4px solid ${
                      voucher.status === "Approved"
                        ? "#4caf50"
                        : voucher.status === "Rejected"
                        ? "#f44336"
                        : "#ff9800"
                    }`,
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mb: 0.5,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                          color: "#666",
                          minWidth: 25,
                        }}
                      >
                        #{index + 1}
                      </Typography>
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          fontSize: "0.85rem",
                          flex: 1,
                        }}
                      >
                        {voucher.sales_number}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "0.75rem",
                          fontWeight: 600,
                          color: "#1976d2",
                        }}
                      >
                        ₹
                        {Number(voucher.total_amount || 0).toLocaleString(
                          "en-IN"
                        )}
                      </Typography>
                      <Chip
                        label={
                          voucher.payment_status === "Paid"
                            ? "Paid"
                            : voucher.payment_status === "Unpaid"
                            ? "Unpaid"
                            : "Partial"
                        }
                        color={
                          voucher.payment_status === "Paid"
                            ? "success"
                            : voucher.payment_status === "Unpaid"
                            ? "error"
                            : "warning"
                        }
                        size="small"
                        sx={{
                          height: "10px",
                          transform: "scale(0.8)",
                          "& .MuiChip-label": {
                            padding: "0 6px",
                          },
                        }}
                      />
                    </Box>
                  </Box>

                  <IconButton size="small" sx={{ ml: 1 }}>
                    {expandedSales === voucher.sales_voucher_no ? (
                      <ExpandLess fontSize="small" />
                    ) : (
                      <ExpandMore fontSize="small" />
                    )}
                  </IconButton>
                </Box>

                <Collapse
                  in={expandedSales === voucher.sales_voucher_no}
                  timeout="auto"
                  unmountOnExit
                >
                  <Box
                    sx={{
                      px: 1.5,
                      py: 1,
                      bgcolor: index % 2 === 0 ? "#f8f9fa" : "#fafafa",
                      borderLeft: `4px solid ${
                        voucher.status === "Approved"
                          ? "#4caf50"
                          : voucher.status === "Rejected"
                          ? "#f44336"
                          : "#ff9800"
                      }`,
                    }}
                  >
                    {/* Amount Details Grid */}
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr 1fr",
                        gap: 0.8,
                        mb: 1,
                        p: 1,
                        bgcolor: "#e3f2fd",
                        borderRadius: "4px",
                      }}
                    >
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#1976d2",
                            letterSpacing: "0.5px",
                          }}
                        >
                          TOTAL
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.75rem",
                            fontWeight: 600,
                            color: "#1976d2",
                          }}
                        >
                          ₹
                          {Number(voucher.total_amount || 0).toLocaleString(
                            "en-IN"
                          )}
                        </Typography>
                      </Box>
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#2e7d32",
                            letterSpacing: "0.5px",
                          }}
                        >
                          RECEIVED
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.75rem",
                            fontWeight: 600,
                            color: "#2e7d32",
                          }}
                        >
                          ₹
                          {Number(voucher.receipt_amount || 0).toLocaleString(
                            "en-IN"
                          )}
                        </Typography>
                      </Box>
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#d32f2f",
                            letterSpacing: "0.5px",
                          }}
                        >
                          BALANCE
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.75rem",
                            fontWeight: 600,
                            color: "#d32f2f",
                          }}
                        >
                          ₹
                          {Number(voucher.balance_amount || 0).toLocaleString(
                            "en-IN"
                          )}
                        </Typography>
                      </Box>
                    </Box>

                    {/* Details Grid */}
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: 0.8,
                        mb: 1,
                      }}
                    >
                      <Box sx={{ gridColumn: "1 / -1" }}>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          DEBTOR
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.75rem",
                            fontWeight: 500,
                            color: "#333",
                          }}
                        >
                          {voucher.company_name || "N/A"}
                        </Typography>
                      </Box>

                      <Box sx={{ gridColumn: "1 / -1" }}>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          PROJECT
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.75rem",
                            fontWeight: 500,
                            color: "#333",
                          }}
                        >
                          {voucher.project_name || "N/A"}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          DIVISION
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {voucher.division_name || "N/A"}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          INVOICE NO
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {voucher.invoice_number || "N/A"}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          DATE
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {formatDate(voucher.created_at)}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          INVOICE DATE
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {formatDate(voucher.invoice_date)}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          CREATED BY
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {voucher.created_by_name || "N/A"}
                        </Typography>
                      </Box>

                      {voucher.approved_name && (
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            APPROVED BY
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 500,
                              color: "#555",
                            }}
                          >
                            {voucher.approved_name}
                          </Typography>
                        </Box>
                      )}
                    </Box>

                    {voucher.remarks && (
                      <Box sx={{ mb: 0.8 }}>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                            mb: 0.3,
                          }}
                        >
                          REMARKS
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.7rem",
                            color: "#555",
                            fontStyle: "italic",
                            lineHeight: 1.3,
                          }}
                        >
                          {voucher.remarks}
                        </Typography>
                      </Box>
                    )}

                    <Divider sx={{ my: 1, borderColor: "#e0e0e0" }} />

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      {userRole != "Staff" && (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            bgcolor:
                              voucher.status === "Approved"
                                ? "#e8f5e9"
                                : voucher.status === "Rejected"
                                ? "#ffebee"
                                : "#fff3e0",
                            px: 1,
                            py: 0.5,
                            borderRadius: "6px",
                            border: `1px solid ${
                              voucher.status === "Approved"
                                ? "#4caf50"
                                : voucher.status === "Rejected"
                                ? "#f44336"
                                : "#ff9800"
                            }`,
                          }}
                        >
                          <Checkbox
                            checked={
                              voucher.status === "Approved" ||
                              voucher.status === "Rejected"
                            }
                            onChange={() => handleCheckboxClick(voucher)}
                            sx={{
                              padding: 0,
                              transform: "scale(0.75)",
                              color:
                                voucher.status === "Approved"
                                  ? "#4caf50"
                                  : voucher.status === "Rejected"
                                  ? "#f44336"
                                  : "#ff9800",
                              "&.Mui-checked": {
                                color:
                                  voucher.status === "Approved"
                                    ? "#4caf50"
                                    : "#f44336",
                              },
                            }}
                          />
                          <Typography
                            sx={{
                              fontSize: "0.7rem",
                              fontWeight: 600,
                              color:
                                voucher.status === "Approved"
                                  ? "#2e7d32"
                                  : voucher.status === "Rejected"
                                  ? "#c62828"
                                  : "#f57c00",
                            }}
                          >
                            {voucher.status === "Approved"
                              ? "Approved"
                              : voucher.status === "Rejected"
                              ? "Rejected"
                              : "Approve"}
                          </Typography>
                        </Box>
                      )}

                      <Box sx={{ display: "flex", gap: 0.6 }}>
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEditClick(voucher);
                          }}
                          disabled={voucher.status === "Approved"}
                          sx={{
                            bgcolor: "#e3f2fd",
                            borderRadius: "6px",
                            width: 32,
                            height: 32,
                            "&:hover": {
                              bgcolor: "#bbdefb",
                              transform: "scale(1.05)",
                            },
                            "&:disabled": {
                              bgcolor: "#f5f5f5",
                              opacity: 0.5,
                            },
                            transition: "all 0.2s",
                          }}
                        >
                          <Edit
                            sx={{
                              fontSize: "1rem",
                              color: "#1976d2",
                              transform: "scale(0.6)",
                            }}
                          />
                        </IconButton>

                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            setAnchorEl(e.currentTarget);
                            setVoucherToDelete(voucher.sales_voucher_no);
                          }}
                          disabled={voucher.status === "Approved"}
                          sx={{
                            bgcolor: "#ffebee",
                            borderRadius: "6px",
                            width: 32,
                            height: 32,
                            "&:hover": {
                              bgcolor: "#ffcdd2",
                              transform: "scale(1.05)",
                            },
                            "&:disabled": {
                              bgcolor: "#f5f5f5",
                              opacity: 0.5,
                            },
                            transition: "all 0.2s",
                          }}
                        >
                          <Delete
                            sx={{
                              fontSize: "1rem",
                              color: "#d32f2f",
                              transform: "scale(0.6)",
                            }}
                          />
                        </IconButton>

                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            generateSalesPdf(voucher);
                          }}
                          sx={{
                            bgcolor: "#fff3e0",
                            borderRadius: "6px",
                            width: 32,
                            height: 32,
                            "&:hover": {
                              bgcolor: "#ffe0b2",
                              transform: "scale(1.05)",
                            },
                            transition: "all 0.2s",
                          }}
                        >
                          <Print
                            sx={{
                              fontSize: "1rem",
                              color: "#f57c00",
                              transform: "scale(0.6)",
                            }}
                          />
                        </IconButton>

                        {typeof voucher.attachment === "string" ? (
                          <a
                            href={`${voucher.attachment}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <IconButton
                              size="small"
                              sx={{
                                bgcolor: "#e8f5e9",
                                borderRadius: "6px",
                                width: 32,
                                height: 32,
                                "&:hover": {
                                  bgcolor: "#c8e6c9",
                                  transform: "scale(1.05)",
                                },
                                transition: "all 0.2s",
                              }}
                            >
                              <Visibility
                                sx={{
                                  fontSize: "1rem",
                                  color: "#2e7d32",
                                  transform: "scale(0.6)",
                                }}
                              />
                            </IconButton>
                          </a>
                        ) : voucher.attachment instanceof File ? (
                          <a
                            href={URL.createObjectURL(voucher.attachment)}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <IconButton
                              size="small"
                              sx={{
                                bgcolor: "#e8f5e9",
                                borderRadius: "6px",
                                width: 32,
                                height: 32,
                                "&:hover": {
                                  bgcolor: "#c8e6c9",
                                  transform: "scale(1.05)",
                                },
                                transition: "all 0.2s",
                              }}
                            >
                              <Visibility
                                sx={{
                                  fontSize: "1rem",
                                  color: "#2e7d32",
                                  transform: "scale(0.6)",
                                }}
                              />
                            </IconButton>
                          </a>
                        ) : null}
                      </Box>
                    </Box>
                  </Box>
                </Collapse>

                <Divider />
              </Box>
            ))}

            {/* Mobile Total Summary */}
            <Box
              sx={{
                p: 2,
                bgcolor: "#e3f2fd",
                position: "sticky",
                bottom: 0,
                borderTop: "2px solid #1976d2",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mb: 0.5,
                }}
              >
                <Typography
                  sx={{
                    fontSize: "0.75rem",
                    fontWeight: "bold",
                    color: "#1976d2",
                  }}
                >
                  Total Amount:
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.75rem",
                    fontWeight: "bold",
                    color: "#1976d2",
                  }}
                >
                  ₹
                  {SalesVouchers.reduce(
                    (sum, v) => sum + parseFloat(v.total_amount || 0),
                    0
                  ).toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mb: 0.5,
                }}
              >
                <Typography
                  sx={{
                    fontSize: "0.75rem",
                    fontWeight: "bold",
                    color: "#2e7d32",
                  }}
                >
                  Total Received:
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.75rem",
                    fontWeight: "bold",
                    color: "#2e7d32",
                  }}
                >
                  ₹
                  {SalesVouchers.reduce(
                    (sum, v) => sum + parseFloat(v.receipt_amount || 0),
                    0
                  ).toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  sx={{
                    fontSize: "0.75rem",
                    fontWeight: "bold",
                    color: "#d32f2f",
                  }}
                >
                  Total Balance:
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.75rem",
                    fontWeight: "bold",
                    color: "#d32f2f",
                  }}
                >
                  ₹
                  {SalesVouchers.reduce(
                    (sum, v) => sum + parseFloat(v.balance_amount || 0),
                    0
                  ).toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </Typography>
              </Box>
            </Box>
          </Box>
        ) : (
          /* 💻 DESKTOP VIEW */
          <TableContainer
            component={Paper}
            sx={{
              maxHeight: "88vh",
              overflow: "auto",
            }}
          >
            <Table
              stickyHeader
              size="small"
              sx={{
                minWidth: 1600,
                "& td, & th": {
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  backgroundColor: "#f5f5f5",
                  borderBottom: "1px solid #ccc",
                },
              }}
            >
              <TableHead>
                <TableRow
                  sx={{
                    backgroundColor: "#f5f5f5",
                    "& th": {
                      fontWeight: "bold",
                      color: "#333",
                      borderBottom: "1px solid #999",
                      whiteSpace: "nowrap",
                      fontSize: "0.75rem",
                    },
                  }}
                >
                  {userRole != "Staff" && (
                    <TableCell
                      sx={{
                        position: "sticky",
                        left: 0,
                        backgroundColor: "#fafafa",
                        zIndex: 3,
                      }}
                    >
                      Approve
                    </TableCell>
                  )}
                  <TableCell
                    sx={{
                      position: "sticky",
                      left: userRole != "Staff" ? 80 : 0,
                      backgroundColor: "#f5f5f5",
                      zIndex: 3,
                    }}
                  >
                    S.No.
                  </TableCell>

                  <TableCell>Sales Voucher No</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Debtor</TableCell>
                  <TableCell>Project</TableCell>
                  <TableCell>Division</TableCell>

                  <TableCell>Total Amt</TableCell>
                  <TableCell>Rec Amt</TableCell>
                  <TableCell>Bal Amt</TableCell>

                  <TableCell>Payment Status</TableCell>
                  <TableCell>Invoice No</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Invoice Date</TableCell>
                  <TableCell>Created By</TableCell>
                  <TableCell>Approved By</TableCell>
                  <TableCell>Remarks</TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      position: "sticky",
                      right: 0,
                      backgroundColor: "#f5f5f5",
                      zIndex: 3,
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {SalesVouchers.map((voucher, index) => (
                  <TableRow
                    hover
                    key={index}
                    sx={{
                      backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                      "&:hover": {
                        backgroundColor: "#e3f2fd",
                        "& td": {
                          backgroundColor: "#e3f2fd !important",
                        },
                      },
                      "& td": {
                        paddingRight: "13px !important",
                        paddingLeft: "13px !important",
                        padding: "0px",
                        fontSize: { xs: "0.65rem", sm: "0.75rem" },
                        whiteSpace: "nowrap",
                        color: (theme) =>
                          theme.palette.mode === "dark" ? "white" : "inherit",
                        backgroundColor: (theme) =>
                          theme.palette.mode === "dark" ? "black" : "inherit",
                      },
                    }}
                  >
                    {userRole != "Staff" && (
                      <TableCell
                        sx={{
                          position: "sticky",
                          left: 0,
                          backgroundColor: "#fafafa",
                          zIndex: 2,
                        }}
                      >
                        <Checkbox
                          checked={
                            voucher.status === "Approved" ||
                            voucher.status === "Rejected"
                          }
                          onChange={() => handleCheckboxClick(voucher)}
                          sx={{
                            padding: 0,
                            paddingLeft: 1,
                            paddingRight: 1,
                            transform: "scale(0.6)",
                            color:
                              voucher.status === "Approved"
                                ? "green"
                                : voucher.status === "Rejected"
                                ? "red"
                                : "grey",
                            "&.Mui-checked": {
                              color:
                                voucher.status === "Approved" ? "green" : "red",
                            },
                          }}
                        />
                      </TableCell>
                    )}
                    <TableCell
                      sx={{
                        position: "sticky",
                        left: userRole != "Staff" ? 80 : 0,
                        backgroundColor: "#f5f5f5",
                        zIndex: 2,
                      }}
                    >
                      {index + 1}
                    </TableCell>

                    <TableCell>{voucher.sales_number}</TableCell>
                    <TableCell align="center">
                      <Chip
                        label={
                          voucher.status === "Approved"
                            ? "Approved"
                            : voucher.status === "Rejected"
                            ? "Rejected"
                            : "Pending"
                        }
                        color={
                          voucher.status === "Approved"
                            ? "success"
                            : voucher.status === "Rejected"
                            ? "error"
                            : "warning"
                        }
                        variant="outlined"
                        size="small"
                        sx={{
                          height: "10px",
                          transform: "scale(0.8)",
                          "& .MuiChip-label": {
                            padding: "0 6px",
                          },
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <Tooltip title={voucher.company_name} arrow>
                        <span>{truncateText(voucher.company_name, 20)}</span>
                      </Tooltip>
                    </TableCell>
                    <TableCell>
                      <Tooltip title={voucher.project_name} arrow>
                        <span>{truncateText(voucher.project_name, 20)}</span>
                      </Tooltip>
                    </TableCell>

                    <TableCell>{voucher.division_name}</TableCell>
                    <TableCell>
                      {Number(voucher.total_amount || 0).toLocaleString(
                        "en-IN"
                      )}
                    </TableCell>
                    <TableCell>
                      {Number(voucher.receipt_amount || 0).toLocaleString(
                        "en-IN"
                      )}
                    </TableCell>
                    <TableCell>
                      {Number(voucher.balance_amount || 0).toLocaleString(
                        "en-IN"
                      )}
                    </TableCell>

                    <TableCell>
                      <Chip
                        label={
                          voucher.payment_status === "Paid"
                            ? "Paid"
                            : voucher.payment_status === "Unpaid"
                            ? "Unpaid"
                            : "Partial"
                        }
                        color={
                          voucher.payment_status === "Paid"
                            ? "success"
                            : voucher.payment_status === "Unpaid"
                            ? "error"
                            : "warning"
                        }
                        variant="outlined"
                        size="small"
                      />
                    </TableCell>

                    <TableCell>{voucher.invoice_number}</TableCell>
                    <TableCell>{formatDate(voucher.created_at)}</TableCell>
                    <TableCell>{formatDate(voucher.invoice_date)}</TableCell>

                    <TableCell>{voucher.created_by_name}</TableCell>
                    <TableCell>{voucher.approved_name}</TableCell>
                    <TableCell>
                      <Tooltip title={voucher.remarks || ""} arrow>
                        <span>{truncateText(voucher.remarks || "", 20)}</span>
                      </Tooltip>
                    </TableCell>
                    <TableCell
                      sx={{
                        position: "sticky",
                        right: 0,
                        backgroundColor: "#f5f5f5",
                        zIndex: 2,
                        minWidth: 180,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: 0.5,
                        }}
                      >
                        <IconButton
                          sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                          size="small"
                          color="primary"
                          onClick={() => handleEditClick(voucher)}
                          disabled={voucher.status === "Approved"}
                        >
                          <Edit transform="scale(0.6)" />
                        </IconButton>

                        <IconButton
                          sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                          size="small"
                          color="error"
                          onClick={(event) => {
                            setAnchorEl(event.currentTarget);
                            setVoucherToDelete(voucher.sales_voucher_no);
                          }}
                          disabled={voucher.status === "Approved"}
                        >
                          <Delete transform="scale(0.6)" />
                        </IconButton>

                        <IconButton
                          sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                          color="warning"
                          size="small"
                          onClick={() => generateSalesPdf(voucher)}
                        >
                          <Print transform="scale(0.6)" />
                        </IconButton>
                        <span
                          style={{
                            display: "inline-block",
                            width: 36,
                            textAlign: "center",
                          }}
                        >
                          {typeof voucher.attachment === "string" ? (
                            <a
                              href={`${voucher.attachment}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <IconButton
                                sx={{
                                  padding: 0,
                                  paddingLeft: 1,
                                  paddingRight: 1,
                                }}
                                color="info"
                                size="small"
                              >
                                <Visibility transform="scale(0.6)" />
                              </IconButton>
                            </a>
                          ) : voucher.attachment instanceof File ? (
                            <a
                              href={URL.createObjectURL(voucher.attachment)}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <IconButton
                                sx={{
                                  padding: 0,
                                  paddingLeft: 1,
                                  paddingRight: 1,
                                }}
                                color="info"
                                size="small"
                              >
                                <Visibility fontSize="small" />
                              </IconButton>
                            </a>
                          ) : (
                            <span
                              style={{ display: "inline-block", width: 24 }}
                            />
                          )}
                        </span>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}

                <TableRow
                  sx={{
                    "& td": {
                      backgroundColor: "#E3F2FD !important",
                      color: "#000 !important",
                      fontWeight: "bold !important",
                    },
                  }}
                >
                  {userRole != "Staff" && <TableCell></TableCell>}
                  <TableCell></TableCell>

                  <TableCell colSpan={5} align="right">
                    Totals:
                  </TableCell>

                  <TableCell>
                    {SalesVouchers.reduce(
                      (sum, v) => sum + parseFloat(v.total_amount || 0),
                      0
                    ).toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </TableCell>

                  <TableCell>
                    {SalesVouchers.reduce(
                      (sum, v) => sum + parseFloat(v.receipt_amount || 0),
                      0
                    ).toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </TableCell>

                  <TableCell>
                    {SalesVouchers.reduce(
                      (sum, v) => sum + parseFloat(v.balance_amount || 0),
                      0
                    ).toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </TableCell>

                  <TableCell colSpan={8}></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </InfiniteScroll>

      {/* Delete Popover */}
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
          setVoucherToDelete(null);
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Box sx={{ p: 2 }}>
          <Typography variant="body2">Are you sure?</Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
            <Button
              color="error"
              size="small"
              onClick={async () => {
                await handleDelete(voucherToDelete);
                setAnchorEl(null);
                setVoucherToDelete(null);
              }}
            >
              Yes
            </Button>
            <Button
              size="small"
              onClick={() => {
                setAnchorEl(null);
                setVoucherToDelete(null);
              }}
            >
              No
            </Button>
          </Box>
        </Box>
      </Popover>

      {/* NEW: Sales Voucher Preview Modal - Exact Design as Image */}
      <Modal
    open={previewModalOpen}
    onClose={() => setPreviewModalOpen(false)}
    aria-labelledby="voucher-preview-modal"
  >
    <Box sx={voucherModalStyle}>
      {/* SALES VOUCHER Header */}
      <Typography
        variant="h5"
        sx={{
          fontWeight: "bold",
          letterSpacing: 1,
          textAlign: "center",
          fontSize: { xs: "1rem", sm: "1.25rem", md: "1.5rem" },
          py: { xs: 1.5, sm: 2 },
          bgcolor: "#f5f5f5",
          borderBottom: "1px solid #e0e0e0",
          position: "sticky",
          top: 0,
          zIndex: 10,
        }}
      >
        SALES VOUCHER
      </Typography>

      {/* Voucher Content Container */}
      <Box
        sx={{
          p: { xs: 1.5, sm: 2, md: 3 },
          background: "linear-gradient(to bottom, #ffffff, #f9f9f9)",
          display: "flex",
          flexDirection: "column",
          gap: { xs: 1.5, sm: 2 },
        }}
      >
        {/* Two-column layout for voucher details */}
        <Box
          sx={{
            border: "1px solid #d0d0d0",
            borderRadius: "4px",
            overflow: "hidden",
          }}
        >
          {/* First Row - Responsive */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              borderBottom: "1px solid #d0d0d0",
              backgroundColor: "#f8f9fa",
            }}
          >
            <Box
              sx={{
                width: { xs: "100%", sm: "50%" },
                borderRight: { xs: "none", sm: "1px solid #d0d0d0" },
                borderBottom: { xs: "1px solid #d0d0d0", sm: "none" },
                p: { xs: 0.75, sm: 1 },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: "bold",
                    fontSize: { xs: "0.65rem", sm: "0.7rem" },
                    color: "#333",
                    minWidth: { xs: "80px", sm: "90px" },
                  }}
                >
                  Voucher No.
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: { xs: "0.7rem", sm: "0.75rem" },
                    fontWeight: 500,
                    color: "#1a237e",
                    wordBreak: "break-word",
                  }}
                >
                  : {selectedVoucher?.sales_number || "N/A"}
                </Typography>
              </Box>
            </Box>

            <Box sx={{ width: { xs: "100%", sm: "50%" }, p: { xs: 0.75, sm: 1 } }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: "bold",
                    fontSize: { xs: "0.65rem", sm: "0.7rem" },
                    color: "#333",
                    minWidth: { xs: "80px", sm: "90px" },
                  }}
                >
                  Invoice Date
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: { xs: "0.7rem", sm: "0.75rem" },
                    fontWeight: 500,
                    color: "#1a237e",
                  }}
                >
                  : {formatDate(selectedVoucher?.invoice_date)}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* Second Row - Responsive */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              borderBottom: "1px solid #d0d0d0",
            }}
          >
            <Box
              sx={{
                width: { xs: "100%", sm: "50%" },
                borderRight: { xs: "none", sm: "1px solid #d0d0d0" },
                borderBottom: { xs: "1px solid #d0d0d0", sm: "none" },
                p: { xs: 0.75, sm: 1 },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: "bold",
                    fontSize: { xs: "0.65rem", sm: "0.7rem" },
                    color: "#333",
                    minWidth: { xs: "80px", sm: "90px" },
                  }}
                >
                  Invoice No
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: { xs: "0.7rem", sm: "0.75rem" },
                    fontWeight: 500,
                    color: "#1a237e",
                    wordBreak: "break-word",
                  }}
                >
                  : {selectedVoucher?.invoice_number || "N/A"}
                </Typography>
              </Box>
            </Box>

            <Box sx={{ width: { xs: "100%", sm: "50%" }, p: { xs: 0.75, sm: 1 } }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: "bold",
                    fontSize: { xs: "0.65rem", sm: "0.7rem" },
                    color: "#333",
                    minWidth: { xs: "80px", sm: "90px" },
                  }}
                >
                  Division
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: { xs: "0.7rem", sm: "0.75rem" },
                    fontWeight: 500,
                    color: "#1a237e",
                    wordBreak: "break-word",
                  }}
                >
                  : {selectedVoucher?.division_name || "N/A"}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* Third Row */}
          <Box sx={{ p: { xs: 0.75, sm: 1 }, backgroundColor: "#f8f9fa" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-start",
                flexWrap: "wrap",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "bold",
                  fontSize: { xs: "0.65rem", sm: "0.7rem" },
                  color: "#333",
                  minWidth: { xs: "80px", sm: "90px" },
                }}
              >
                Project Name
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontSize: { xs: "0.7rem", sm: "0.75rem" },
                  fontWeight: 500,
                  color: "#1a237e",
                  wordBreak: "break-word",
                  flex: 1,
                }}
              >
                : {selectedVoucher?.project_name || "N/A"}
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Amount Section - Responsive */}
        <Box
          sx={{
            border: "1px solid #d0d0d0",
            borderRadius: "4px",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              backgroundColor: "#f8f9fa",
            }}
          >
            <Box
              sx={{
                width: { xs: "100%", sm: "33.33%" },
                p: { xs: 0.75, sm: 1 },
                borderRight: { xs: "none", sm: "1px solid #d0d0d0" },
                borderBottom: { xs: "1px solid #d0d0d0", sm: "none" },
                textAlign: "center",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "bold",
                  fontSize: { xs: "0.65rem", sm: "0.7rem" },
                  color: "#333",
                  mb: 0.3,
                }}
              >
                Basic Value
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontSize: { xs: "0.75rem", sm: "0.8rem" },
                  fontWeight: 600,
                  color: "#1a237e",
                }}
              >
                ₹{Number(selectedVoucher?.amount || 0).toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                })}
              </Typography>
            </Box>

            <Box
              sx={{
                width: { xs: "100%", sm: "33.33%" },
                p: { xs: 0.75, sm: 1 },
                borderRight: { xs: "none", sm: "1px solid #d0d0d0" },
                borderBottom: { xs: "1px solid #d0d0d0", sm: "none" },
                textAlign: "center",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "bold",
                  fontSize: { xs: "0.65rem", sm: "0.7rem" },
                  color: "#333",
                  mb: 0.3,
                }}
              >
                GST Amount
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontSize: { xs: "0.75rem", sm: "0.8rem" },
                  fontWeight: 600,
                  color: "#d32f2f",
                }}
              >
                ₹{Number(selectedVoucher?.gst_amount || 0).toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                })}
              </Typography>
            </Box>

            <Box
              sx={{
                width: { xs: "100%", sm: "33.33%" },
                p: { xs: 0.75, sm: 1 },
                textAlign: "center",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "bold",
                  fontSize: { xs: "0.65rem", sm: "0.7rem" },
                  color: "#333",
                  mb: 0.3,
                }}
              >
                Grand Total
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontSize: { xs: "0.75rem", sm: "0.8rem" },
                  fontWeight: 600,
                  color: "#2e7d32",
                }}
              >
                ₹{Number(selectedVoucher?.total_amount || 0).toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                })}
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Payment Status and Narration - Responsive */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: 1,
          }}
        >
          <Box sx={{ flex: { xs: "none", sm: 1 }, width: { xs: "100%", sm: "auto" } }}>
            <Box
              sx={{
                border: "1px solid #d0d0d0",
                borderRadius: "4px",
                p: { xs: 0.75, sm: 1 },
                backgroundColor: "#f8f9fa",
                height: "100%",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "bold",
                  fontSize: { xs: "0.65rem", sm: "0.7rem" },
                  color: "#333",
                  mb: 0.5,
                }}
              >
                Payment Status
              </Typography>
              <Chip
                label={
                  selectedVoucher?.payment_status === "Overpaid"
                    ? "Overpaid"
                    : selectedVoucher?.payment_status === "Paid"
                    ? "Paid"
                    : selectedVoucher?.payment_status === "Partial"
                    ? "Partial"
                    : "Unpaid"
                }
                color={
                  selectedVoucher?.payment_status === "Overpaid"
                    ? "info"
                    : selectedVoucher?.payment_status === "Paid"
                    ? "success"
                    : selectedVoucher?.payment_status === "Partial"
                    ? "warning"
                    : "error"
                }
                size="small"
                sx={{
                  fontSize: { xs: "0.65rem", sm: "0.7rem" },
                  fontWeight: "bold",
                  height: { xs: "18px", sm: "20px" },
                }}
              />
            </Box>
          </Box>

          <Box sx={{ flex: { xs: "none", sm: 2 }, width: { xs: "100%", sm: "auto" } }}>
            <Box
              sx={{
                border: "1px solid #d0d0d0",
                borderRadius: "4px",
                p: { xs: 0.75, sm: 1 },
                backgroundColor: "#f8f9fa",
                height: "100%",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "bold",
                  fontSize: { xs: "0.65rem", sm: "0.7rem" },
                  color: "#333",
                  mb: 0.3,
                }}
              >
                Narration
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontSize: { xs: "0.7rem", sm: "0.75rem" },
                  color: "#555",
                  lineHeight: 1.3,
                  maxHeight: { xs: "60px", sm: "40px" },
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  wordBreak: "break-word",
                }}
              >
                {selectedVoucher?.remarks || "No remarks"}
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* DEBTOR DETAILS Header */}
        <Box
          sx={{
            bgcolor: "#e3f2fd",
            color: "#1a237e",
            textAlign: "center",
            py: { xs: 0.5, sm: 0.75 },
            border: "1px solid #bbdefb",
            borderRadius: "4px",
          }}
        >
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: "bold",
              fontSize: { xs: "0.75rem", sm: "0.85rem" },
            }}
          >
            DEBTOR DETAILS
          </Typography>
        </Box>

        {/* Debtor Details Grid - Responsive */}
        <Box
          sx={{
            border: "1px solid #d0d0d0",
            borderRadius: "4px",
            overflow: "hidden",
          }}
        >
          {/* Debtor First Row */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              borderBottom: "1px solid #d0d0d0",
              backgroundColor: "#f8f9fa",
            }}
          >
            <Box
              sx={{
                width: { xs: "100%", sm: "50%" },
                borderRight: { xs: "none", sm: "1px solid #d0d0d0" },
                borderBottom: { xs: "1px solid #d0d0d0", sm: "none" },
                p: { xs: 0.75, sm: 1 },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  flexWrap: "wrap",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: "bold",
                    fontSize: { xs: "0.65rem", sm: "0.7rem" },
                    color: "#333",
                    minWidth: { xs: "80px", sm: "100px" },
                  }}
                >
                  Debtor
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: { xs: "0.7rem", sm: "0.75rem" },
                    color: "#555",
                    wordBreak: "break-word",
                    flex: 1,
                  }}
                >
                  : {selectedVoucher?.debtor?.company_name || "N/A"}
                </Typography>
              </Box>
            </Box>

            <Box sx={{ width: { xs: "100%", sm: "50%" }, p: { xs: 0.75, sm: 1 } }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: "bold",
                    fontSize: { xs: "0.65rem", sm: "0.7rem" },
                    color: "#333",
                    minWidth: { xs: "80px", sm: "100px" },
                  }}
                >
                  GST No
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: { xs: "0.7rem", sm: "0.75rem" },
                    color: "#555",
                    wordBreak: "break-all",
                  }}
                >
                  : {selectedVoucher?.debtor?.gst || "N/A"}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* Debtor Second Row */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              borderBottom: "1px solid #d0d0d0",
            }}
          >
            <Box
              sx={{
                width: { xs: "100%", sm: "50%" },
                borderRight: { xs: "none", sm: "1px solid #d0d0d0" },
                borderBottom: { xs: "1px solid #d0d0d0", sm: "none" },
                p: { xs: 0.75, sm: 1 },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: "bold",
                    fontSize: { xs: "0.65rem", sm: "0.7rem" },
                    color: "#333",
                    minWidth: { xs: "80px", sm: "100px" },
                  }}
                >
                  Contact Name
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: { xs: "0.7rem", sm: "0.75rem" },
                    color: "#555",
                    wordBreak: "break-word",
                  }}
                >
                  : {selectedVoucher?.debtor?.name || "N/A"}
                </Typography>
              </Box>
            </Box>

            <Box sx={{ width: { xs: "100%", sm: "50%" }, p: { xs: 0.75, sm: 1 } }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: "bold",
                    fontSize: { xs: "0.65rem", sm: "0.7rem" },
                    color: "#333",
                    minWidth: { xs: "80px", sm: "100px" },
                  }}
                >
                  PAN No
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: { xs: "0.7rem", sm: "0.75rem" },
                    color: "#555",
                  }}
                >
                  : {selectedVoucher?.debtor?.pan || "N/A"}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* Debtor Third Row */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              borderBottom: "1px solid #d0d0d0",
            }}
          >
            <Box
              sx={{
                width: { xs: "100%", sm: "50%" },
                borderRight: { xs: "none", sm: "1px solid #d0d0d0" },
                borderBottom: { xs: "1px solid #d0d0d0", sm: "none" },
                p: { xs: 0.75, sm: 1 },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  flexWrap: "wrap",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: "bold",
                    fontSize: { xs: "0.65rem", sm: "0.7rem" },
                    color: "#333",
                    minWidth: { xs: "80px", sm: "100px" },
                  }}
                >
                  Email
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: { xs: "0.7rem", sm: "0.75rem" },
                    color: "#555",
                    wordBreak: "break-all",
                    flex: 1,
                  }}
                >
                  : {selectedVoucher?.debtor?.email || "N/A"}
                </Typography>
              </Box>
            </Box>

            <Box sx={{ width: { xs: "100%", sm: "50%" }, p: { xs: 0.75, sm: 1 } }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  flexWrap: "wrap",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: "bold",
                    fontSize: { xs: "0.65rem", sm: "0.7rem" },
                    color: "#333",
                    minWidth: { xs: "80px", sm: "100px" },
                  }}
                >
                  Address
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: { xs: "0.7rem", sm: "0.75rem" },
                    color: "#555",
                    maxHeight: { xs: "50px", sm: "35px" },
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    wordBreak: "break-word",
                    flex: 1,
                  }}
                >
                  : {selectedVoucher?.debtor?.address || "N/A"}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* Debtor Fourth Row */}
          <Box sx={{ p: { xs: 0.75, sm: 1 }, backgroundColor: "#f8f9fa" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "bold",
                  fontSize: { xs: "0.65rem", sm: "0.7rem" },
                  color: "#333",
                  minWidth: { xs: "80px", sm: "100px" },
                }}
              >
                Phone No
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontSize: { xs: "0.7rem", sm: "0.75rem" },
                  color: "#555",
                }}
              >
                : {selectedVoucher?.debtor?.contact || "N/A"}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Modal Footer - Responsive */}
      <Box
        sx={{
          p: { xs: 1, sm: 1.5 },
          bgcolor: "#f5f5f5",
          borderTop: "1px solid #e0e0e0",
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "stretch", sm: "center" },
          gap: { xs: 1, sm: 0 },
          position: "sticky",
          bottom: 0,
          zIndex: 10,
        }}
      >
        {/* Edit Button */}
        <Button
          variant="outlined"
          color="primary"
          size="small"
          onClick={() => {
            if (selectedVoucher?.status !== "Approved") {
              setPreviewModalOpen(false);
              handleEditClick(selectedVoucher);
            }
          }}
          disabled={selectedVoucher?.status === "Approved"}
          startIcon={<Edit fontSize="small" />}
          sx={{
            minWidth: { xs: "100%", sm: 80 },
            fontSize: { xs: "0.7rem", sm: "0.75rem" },
            py: 0.5,
            order: { xs: 2, sm: 1 },
          }}
        >
          Edit
        </Button>

        {/* Action Buttons */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: { xs: 0.5, sm: 0.5 },
            order: { xs: 1, sm: 2 },
          }}
        >
          {/* Close Button */}
          <Button
            variant="outlined"
            size="small"
            onClick={() => setPreviewModalOpen(false)}
            sx={{
              minWidth: { xs: "100%", sm: 80 },
              fontSize: { xs: "0.7rem", sm: "0.75rem" },
              py: 0.5,
            }}
          >
            Close
          </Button>

          {/* Status based buttons */}
          {selectedVoucher?.status === "Rejected" && (
            <Button
              variant="contained"
              color="success"
              size="small"
              onClick={() => handleOpenRemarkDialog("Approved")}
              sx={{
                minWidth: { xs: "100%", sm: 80 },
                fontSize: { xs: "0.7rem", sm: "0.75rem" },
                py: 0.5,
              }}
            >
              Approve
            </Button>
          )}

          {selectedVoucher?.status === "Pending" && (
            <>
              <Button
                variant="contained"
                color="error"
                size="small"
                onClick={() => handleOpenRemarkDialog("Rejected")}
                sx={{
                  minWidth: { xs: "100%", sm: 80 },
                  fontSize: { xs: "0.7rem", sm: "0.75rem" },
                  py: 0.5,
                }}
              >
                Reject
              </Button>
              <Button
                variant="contained"
                color="success"
                size="small"
                onClick={() => handleOpenRemarkDialog("Approved")}
                sx={{
                  minWidth: { xs: "100%", sm: 80 },
                  fontSize: { xs: "0.7rem", sm: "0.75rem" },
                  py: 0.5,
                }}
              >
                Approve
              </Button>
            </>
          )}

          {selectedVoucher?.status === "Approved" && (
            <Chip
              label="Approved"
              color="success"
              size="small"
              sx={{
                minWidth: { xs: "100%", sm: 80 },
                fontSize: { xs: "0.7rem", sm: "0.75rem" },
                height: { xs: "28px", sm: "32px" },
                justifyContent: "center",
              }}
            />
          )}

          {selectedVoucher?.status === "Rejected" &&
            selectedVoucher?.status !== "Pending" && (
              <Chip
                label="Rejected"
                color="error"
                size="small"
                sx={{
                  minWidth: { xs: "100%", sm: 80 },
                  fontSize: { xs: "0.7rem", sm: "0.75rem" },
                  height: { xs: "28px", sm: "32px" },
                  justifyContent: "center",
                }}
              />
            )}
        </Box>
      </Box>
    </Box>
  </Modal>

  {/* Remark Input Dialog Box - Responsive */}
  <Modal
    open={remarkModalOpen}
    onClose={() => setRemarkModalOpen(false)}
    aria-labelledby="remark-dialog-modal"
  >
    <Box sx={remarkModalStyle}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: { xs: 1.5, sm: 2 },
        }}
      >
        <Typography
          id="remark-dialog-modal"
          variant="h6"
          sx={{
            color: actionType === "Approved" ? "#2e7d32" : "#d32f2f",
            fontWeight: "bold",
            fontSize: { xs: "1rem", sm: "1.25rem" },
          }}
        >
          {actionType === "Approved" ? "Approve Voucher" : "Reject Voucher"}
        </Typography>
        <IconButton size="small" onClick={() => setRemarkModalOpen(false)}>
          <Close />
        </IconButton>
      </Box>

      <Box sx={{ mb: { xs: 2, sm: 3 } }}>
        <Typography variant="body2" sx={{ mb: 1, fontSize: { xs: "0.8rem", sm: "0.875rem" } }}>
          Voucher No: <strong>{selectedVoucher?.sales_number}</strong>
        </Typography>
        <Typography variant="body2" sx={{ mb: 2, fontSize: { xs: "0.8rem", sm: "0.875rem" } }}>
          Are you sure you want to{" "}
          {actionType === "Approved" ? "approve" : "reject"} this voucher?
        </Typography>
      </Box>

      <Box sx={{ mb: { xs: 2, sm: 3 } }}>
        <Typography
          variant="body2"
          sx={{ mb: 1, fontWeight: "bold", fontSize: { xs: "0.8rem", sm: "0.875rem" } }}
        >
          Please enter a remark (required):
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={3}
          value={remarkInput}
          onChange={(e) => setRemarkInput(e.target.value)}
          placeholder={`Enter reason for ${
            actionType === "Approved" ? "approval" : "rejection"
          }...`}
          sx={{
            "& .MuiOutlinedInput-root": {
              fontSize: { xs: "0.8rem", sm: "0.875rem" },
              "&:focus-within": {
                borderColor: actionType === "Approved" ? "#4caf50" : "#f44336",
              },
            },
          }}
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: { xs: "stretch", sm: "flex-end" },
          gap: { xs: 1, sm: 2 },
        }}
      >
        <Button
          variant="outlined"
          onClick={() => setRemarkModalOpen(false)}
          sx={{
            minWidth: { xs: "100%", sm: 100 },
            fontSize: { xs: "0.8rem", sm: "0.875rem" },
            order: { xs: 2, sm: 1 },
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color={actionType === "Approved" ? "success" : "error"}
          onClick={handleApproveReject}
          disabled={!remarkInput.trim()}
          sx={{
            minWidth: { xs: "100%", sm: 100 },
            fontSize: { xs: "0.8rem", sm: "0.875rem" },
            order: { xs: 1, sm: 2 },
          }}
        >
          Confirm
        </Button>
      </Box>
    </Box>
  </Modal>
    </>
  );
};

export default SalesVouchers;
